import styled from "styled-components";
import { GlobalWrapper } from "shared/Styles/Wrappers";

export const Container = styled(GlobalWrapper)`
  width: 100%;
  display: flex;
`;

export const VideoBox = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
